import { HttpContextToken } from '@angular/common/http';

export const SKIP_LTS_LOGOUT_FOR_LOGIN = new HttpContextToken(() => false);
export const SKIP_AUTH = new HttpContextToken(() => false);
